import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DvlaDetailsPage } from './dvla-details.page';

const routes: Routes = [
  {
    path: '',
    component: DvlaDetailsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DvlaDetailsPageRoutingModule {}
